import React, { useEffect } from "react";
import Breadcrumbs from "../../core/breadcrumbs";
import { Link } from "react-router-dom";
import { Edit, Eye, Trash2 } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddSupplierModal from "../../core/modals/peoples/addSupplierModal";
import UpdateSupplierModal from "../../core/modals/peoples/updateSupplierModal";
import {set_supplier_edit, set_supplier_list, set_page_refresh} from "../../core/redux/action";
import axios from "axios";
import { dateFormatter } from "../../plugins/helper";

const Suppliers = () => {
  const dispatch = useDispatch();
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const data = useSelector((state) => state.supplier_list);
  const pageRefresh = useSelector((state) => (state.pageRefresh?.suppliers || 0));

  useEffect(() => {
    async function fetchData() {
      let result = await axios.get("getusersuppliers/");
      console.log(result)
      dispatch(set_supplier_list(result.data))
    }
    fetchData()
  }, [pageRefresh])

  const columns = [
   
    {
      title: t?.[l]?.["supplier_name"] || "Supplier Name",
      dataIndex: "name",
      // sorter: (a, b) => a.name.length - b.name.length,
    },
    

    {
      title: t?.[l]?.["email"] || "Email",
      dataIndex: "email",
      // sorter: (a, b) => a.email.length - b.email.length,
    },

    {
      title: t?.[l]?.["phone"] || "Phone",
      dataIndex: "contactNo",
      // sorter: (a, b) => a.contactNo.length - b.contactNo.length,
    },
    {
      title: t?.[l]?.["city"] || "City",
      dataIndex: "city",
      // sorter: (a, b) => a.city.length - b.city.length,
    },

    {
      title: t?.[l]?.["country"] || "Country",
      dataIndex: "country",
      render: (text) => {
        if(text != "")
        return <span className="">{t?.[l]?.[text?.toLowerCase()] || text}</span>;
      }
    },
    {
      title: t?.[l]?.["created_at"] || "Created At",
      dataIndex: "createdAt",
      render(text) {
        return <span>{dateFormatter(text,l)}</span>
      },
      // sorter: (a, b) => a.createdAt.length - b.createdAt.length,
    },

    {
      title: t?.[l]?.["action"] || "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

            <Link className="me-2 p-2 hidden" to="#">
              <Eye className="feather-view" />
            </Link>
            {canUpdate && (
              <Link
                className="me-2 p-2"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#edit-units"
                onClick={() => {
                  dispatch(set_supplier_edit(record));
                }}
              >
                <Edit className="feather-edit" />
              </Link>
            )}
            {canDelete && (
              <Link
                className="confirm-text p-2"
                to="#"
                onClick={(e) => {showConfirmationAlert(e,record)}}
              >
                <Trash2 className="feather-trash-2" />
              </Link>
            )}
          </div>
        </div>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (e,record) => {
    e.preventDefault();
    MySwal.fire({
      title: t?.[l]?.["are_you_sure?"] || "Are you sure?",
      text: t?.[l]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: t?.[l]?.["yes,_delete_it!"] || "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: t?.[l]?.["cancel"] || "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let result = await axios.post("removesupplier/", record);
          dispatch(set_page_refresh("suppliers"))
          console.log(result)
          MySwal.fire({
            title: t?.[l]?.["deleted!"] || "Deleted!",
            text: t?.[l]?.["item_has_been_deleted."] || "Item has been deleted.",
            className: "btn btn-success",
            confirmButtonText: t?.[l]?.["ok"] || "OK",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then(() => {
          });
        } catch(e) {
          console.log(e)
          return false;
        }
        
      } else {
        MySwal.close();
      }
    });
  };
  
  //Permissions
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || [];
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || [];
  
  // Check permissions
  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'view');
  const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'create');
  const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'update');
  const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'delete');

  if (!canView) {
      return ( 
      <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
  )}

  return (
    <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
      <div className="content">
      {canCreate ? (
      <Breadcrumbs
        maintitle={t?.[l]?.["supplier_list"] || "Supplier List "}
        subtitle={t?.[l]?.["manage_your_supplier"] || "Manage Your Supplier"}
        addButton={t?.[l]?.["add_new_supplier"] || "Add New Supplier"}
        onClick={() => dispatch(set_supplier_edit({}))}
      />
    ) : null}
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <Table
                className="table datanew"
                columns={columns}
                dataSource={data}
                rowKey={(record) => record._id}
                // pagination={true}
              />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>

      <AddSupplierModal />
      <UpdateSupplierModal />
    </div>
  );
};

export default Suppliers;
